'use client'

import { JSX } from 'react'
import { Category } from '@/payload-types'
import { Locale } from '@/providers/Locale/types'

import { type Props as OneColListProps } from '@/components/frontend/Layouts/OneColList'
import { i18n, KnownCategories } from './i18n'
import { PostList } from '@/components/frontend/PostList'

type Props = {
    categoryKey: KnownCategories
    category: Category
    nextPage: number
    locale: Locale
    options?: OneColListProps
}

export function SubCategoryClient({ category, categoryKey, nextPage, locale, options = {} }: Props): JSX.Element {
    const posts = category.relatedPosts?.docs

    return (
        <PostList
            options={{
                heading: {
                    title: category.title,
                    tagline: category.description || i18n[locale][categoryKey].description,
                },
                ...options,
            }}
            classes={{ nextButton: 'hover:bg-slate-200' }}
            nextPage={nextPage}
            hasNextPage={!!category.relatedPosts?.hasNextPage}
            nextButtonText='Next'
            locale={locale}
            posts={posts}
        />
    )
}
